import Vue from 'vue'
import Router from 'vue-router'
import ActivityPage from '@/components/ActivityPage'
import HelpFriendPage from '@/components/HelpFriendPage'

Vue.use(Router)


export default new Router({
  routes: [
    {
      path: '/',
      name: 'ActivityPage',
      component: ActivityPage
    },
    {
      path:'/helpfriend',
      name: 'HelpFriendPage',
      component: HelpFriendPage,
      meta: {
        title: '助力好友免费玩转增值版人脸SDK'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js